import React from 'react';
import PropTypes from 'prop-types';
import { isSameMonth, format } from 'date-fns';
import Button from './Button';
import ArrowIcon from './ArrowIcon';

function CalendarHeader({
	month,
	onPreviousClick,
	onNextClick,
	today,
	allValid,
}) {
	const isPrevDisabled = !allValid && isSameMonth(today, month);

	return (
		<div className="calendar-header">
			<Button
				className="previous"
				onClick={onPreviousClick}
				disabled={isPrevDisabled}
			>
				<ArrowIcon direction="left" color="currentColor" />
			</Button>
			<span className="month">{format(month, 'MMMM yyyy')}</span>
			<Button className="next" onClick={onNextClick}>
				<ArrowIcon direction="right" color="currentColor" />
			</Button>
		</div>
	);
}

CalendarHeader.propTypes = {
	month: PropTypes.instanceOf(Date),
	today: PropTypes.instanceOf(Date),
	allValid: PropTypes.bool,
	onPreviousClick: PropTypes.func,
	onNextClick: PropTypes.func,
};

CalendarHeader.defaultProps = {
	month: new Date(),
	today: new Date(),
	allValid: false,
};

export default CalendarHeader;
